import http from './http.service';

class ParticipationRelationTypeService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/ParticipationRelationType";
    }

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/create`, model);
    }

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/update`, model);
    }

    activate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/activate`, { params: { id: id } });
    }

    deactivate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivate`, { params: { id: id } });
    }

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/delete`, { params: { id: id } });
    }
}

export default new ParticipationRelationTypeService();
